import { useCallback, useState } from "react"

import erreurSound from "../../../assets/sons/erreur.wav"
import validationSound from "../../../assets/sons/validation.wav"
import { useSoundEffect } from "../../../clux-ui/hooks"
import {
  CORRECT_SELECTION_MESSAGE,
  REJECTION_MESSAGES,
  SILENT_REJECTIONS,
} from "./config/constants"
import { SelectionOutcome } from "./config/interfaces"
import { isRejection } from "./helpers/game"

/**
 * Retour donné au joueur après un clic sur une tuile :
 * son, tremblement de la tuile refusée et message pour les lecteurs d'écran.
 */
export const useSelectionFeedback = () => {
  const playError = useSoundEffect(erreurSound)
  const playValidation = useSoundEffect(validationSound)
  const [shakingTileId, setShakingTileId] = useState<string | null>(null)
  const [feedbackMessage, setFeedbackMessage] = useState("")

  const giveFeedback = useCallback(
    (tileId: string, outcome: SelectionOutcome) => {
      if (isRejection(outcome)) {
        if (!SILENT_REJECTIONS.includes(outcome)) {
          playError()
        }
        setShakingTileId(tileId)
        setFeedbackMessage(REJECTION_MESSAGES[outcome])
        return
      }
      if (outcome === "correct") {
        playValidation()
        setFeedbackMessage(CORRECT_SELECTION_MESSAGE)
        return
      }
      // Mode libre : l'état de la tuile (aria-pressed) suffit à informer le joueur
      setFeedbackMessage("")
    },
    [playError, playValidation],
  )

  const clearShake = useCallback(() => setShakingTileId(null), [])

  return { shakingTileId, feedbackMessage, giveFeedback, clearShake }
}
